import React, { useState } from 'react'
import { supabase } from '../lib/supabase'

export default function Login() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [showReset, setShowReset] = useState(false)
  const [resetSent, setResetSent] = useState(false)

  const handleLogin = async (e) => {
    e.preventDefault()
    setLoading(true)
    setError('')
    const { error } = await supabase.auth.signInWithPassword({ email, password })
    if (error) setError(error.message)
    setLoading(false)
  }

  const handleReset = async (e) => {
    e.preventDefault()
    if (!email) { setError('Enter your email address above first'); return }
    setLoading(true)
    setError('')
    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: `${window.location.origin}/reset-password`,
    })
    if (error) {
      if (error.message.includes('rate limit') || error.status === 429) {
        setError('Too many requests. Please wait a few minutes before trying again.')
      } else {
        setError(error.message)
      }
    }
    else setResetSent(true)
    setLoading(false)
  }

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-logo">Crew Dispatch</div>
        <div className="login-tagline">Manpower scheduling for your team</div>
        {error && <div className="login-error">{error}</div>}
        {resetSent ? (
          <div style={{ textAlign: 'center', padding: '16px 0' }}>
            <div style={{ fontSize: 32, marginBottom: 8 }}>📧</div>
            <div style={{ fontWeight: 600, marginBottom: 6 }}>Check your email</div>
            <div style={{ fontSize: 13, color: 'var(--text3)', marginBottom: 16 }}>
              We sent a password reset link to <strong>{email}</strong>
            </div>
            <button className="btn" onClick={() => { setResetSent(false); setShowReset(false) }} style={{ fontSize: 13 }}>
              Back to sign in
            </button>
          </div>
        ) : (
          <form onSubmit={showReset ? handleReset : handleLogin}>
            <div className="form-group">
              <label className="form-label">Email</label>
              <input className="form-input" type="email" value={email}
                onChange={e => setEmail(e.target.value)} placeholder="you@company.com" required />
            </div>
            {!showReset && (
              <div className="form-group">
                <label className="form-label">Password</label>
                <input className="form-input" type="password" value={password}
                  onChange={e => setPassword(e.target.value)} placeholder="••••••••" required />
              </div>
            )}
            <button className="btn btn-primary btn-full" type="submit" disabled={loading}>
              {loading ? '...' : showReset ? 'Send reset link' : 'Sign in'}
            </button>
            <div style={{ textAlign: 'center', marginTop: 14 }}>
              <button type="button" onClick={() => { setShowReset(!showReset); setError('') }}
                style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 12, color: 'var(--text3)', textDecoration: 'underline' }}>
                {showReset ? 'Back to sign in' : 'Forgot password?'}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  )
}
